function equipment() {

  // При клике на чекер в блоке с оранжевой машиной

  let eqCheckbox = $('.js-equipment-checkbox'); // чекеры
  let eqRightImgOrange = $('.js-equipment-flex-list__img_orange'); // правые картинки оранжевые
  let eqRightImgGrey = $('.js-equipment-flex-list__img_grey'); // правые картинки серые
  let eqListItem = $('.js-equipment-flex-list__item'); // элемент вертикального списка с чекерами

  let eqLeftImgGrey = $('.js-equipment-overlay__img_grey'), // левые картинки на машине
    eqLeftImgOrange = $('.js-equipment-overlay__img_orange');



  // Обработка события нажатого чекера

  $(document).on('change', '.js-equipment-checkbox', function () {
    if (this.checked) { // если чекер стоит

      // console.log(eqCheckbox.index(this)); // получаем индекс выбранного чекера
      // console.log(eqRightImg[eqCheckbox.index(this)]); // получаем индекс соответствующей картинки

      // Скрываем одну картинку и показываем другую с оранжевым фоном
      eqRightImgOrange[eqCheckbox.index(this)].style.display = 'none';
      eqRightImgGrey[eqCheckbox.index(this)].style.display = 'block';
      eqRightImgGrey[eqCheckbox.index(this)].style.backgroundColor = '#FF7A00'; // у картинки с тем же индексом что и у чекера меняем фон
      eqListItem[eqCheckbox.index(this)].style.backgroundColor = 'rgb(255, 122, 0, 0.2)'; // меняем фон на светло-оранжевый

      // Заменяем неактивный серый блок слева на активный оранжевый
      eqLeftImgGrey[eqCheckbox.index(this)].style.display = 'none';
      eqLeftImgOrange[eqCheckbox.index(this)].style.display = 'block';

    } else { // чекер не стоит

      // Скрываем одну картинку и показываем другую с серым фоном
      eqRightImgOrange[eqCheckbox.index(this)].style.display = 'block';
      eqRightImgGrey[eqCheckbox.index(this)].style.display = 'none';
      eqRightImgOrange[eqCheckbox.index(this)].style.backgroundColor = 'rgba(204, 204, 204, 0.4)'; // у картинки с тем же индексом что и у чекера меняем фон обратно
      eqListItem[eqCheckbox.index(this)].style.backgroundColor = 'rgba(204, 204, 204, 0.2)'; // меняем фон обратно на светло-серый
      eqLeftImgGrey[eqCheckbox.index(this)].style.display = 'block';  // Заменяем активный оранжевый блок слева на неактивный серый
      eqLeftImgOrange[eqCheckbox.index(this)].style.display = 'none';
    };
  });

  // Обработка выбранных чекеров
  $(document).on('change', '.js-equipment-checkbox', function () {
    $('.js-equipment__result span').first().text('0');
    $('.js-equipment-flex-list__item input').each(function() {
      if ($(this).prop('checked')) {
        $('.js-equipment__result span').first().text(Number($('.js-equipment__result span').first().text())+Number($(this).val()));
      }
    })
  });

  $('.js-equipment-overlay__img').click(function(){
    if ($(this).hasClass('js-equipment-overlay__img_grey')) {
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] input').prop('checked','checked');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+']').css('background-color','rgb(255, 122, 0, 0.2)');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] img.js-equipment-flex-list__img_orange').css('display','none');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] img.js-equipment-flex-list__img_grey').css('display','block');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] img.js-equipment-flex-list__img_grey').css('background-color','rgb(255, 122, 0)')
      $(this).css('display','none');
      $('.js-equipment-overlay__img_orange[data-equip='+$(this).data('equip')+']').css('display','block');
    } else {
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] input').prop('checked','');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+']').css('background-color','rgba(204, 204, 204, 0.2)');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] img.js-equipment-flex-list__img_orange').css('display','block');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] img.js-equipment-flex-list__img_grey').css('display','none');
      $('.js-equipment-flex-list__item[data-equip='+$(this).data('equip')+'] img.js-equipment-flex-list__img_grey').css('background-color','rgb(255, 122, 0)')
      $(this).css('display','none');
      $('.js-equipment-overlay__img_grey[data-equip='+$(this).data('equip')+']').css('display','block');
    }
    $('.js-equipment__result span').first().text('0');
    $('.js-equipment-flex-list__item input').each(function() {
      if ($(this).prop('checked')) {
        $('.js-equipment__result span').first().text(Number($('.js-equipment__result span').first().text())+Number($(this).val()));
      }
    })
  })

}

export {
  equipment
};
